'use strict';

import { Color, Fog, ShaderMaterial } from 'three';
import { projectMode, threeJsVariables } from '../../../settings';
import rainVertex from '../../threejs/Shaders/weather/rain/vertexShader.glsl';
import rainFragment from '../../threejs/Shaders/weather/rain/fragmentShader.glsl';
import { basic_tile } from '../../threejs/environment';
import { OrbitDayAndNight } from '../../liveAnimations/DayNight/OrbitDayAndNight';
import { Weather } from './Weather';
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass';
import { Effect } from '../../post-processing/Passes/Effect';
import { resetFogToDefault, setFogParams } from '../../post-processing/Passes/Fog';



export class Rain {
    static #material = null;
    static #params = {
        rainSpatialDensityX: 100.0,
        rainSpatialDensityY: 33.0,
        rainMaxDensity: 0.4,
        rainSpeed: 20.0,
        dropletLength: 1.0,
        dropletWidth: 0.01,
        fogFar: config.features?.weather?.settings?.rain?.fogFar || 0.5
    };

    constructor () {

        this.fogColor = new Color(0.47,0.47,0.47);
        this.envFogDensity = 0.0015;
        this.bgFogDensity = 0.0015;

        Rain.#material = new ShaderMaterial({
            vertexShader: rainVertex,
            fragmentShader: rainFragment,
            uniforms: {
                tDiffuse: {
                    value: null
                },
                uTime: {
                    value: 0
                },
                rainSpatialDensityX: {
                    value: Rain.#params.rainSpatialDensityX
                },
                rainSpatialDensityY: {
                    value: Rain.#params.rainSpatialDensityY
                },
                rainMaxDensity: {
                    value: Rain.#params.rainMaxDensity
                },
                rainSpeed: {
                    value: Rain.#params.rainSpeed
                },
                dropletLength: {
                    value: Rain.#params.dropletLength
                },
                dropletWidth: {
                    value: Rain.#params.dropletWidth
                }
            },
            depthWrite: false,
            depthTest: false
        });

        // this.effect = new PostFX('rain',threeJsVariables.renderer,Rain.#material);
        this.effect = new RainEffect(Rain.#material);
        threeJsVariables.composer.addPass('rain',this.effect);

        // const gui = new dat.GUI();
        //
        // gui.add(options,'rainSpatialDensityX',0.0,100.0, 0.01).onChange((v) =>{
        //     this.material.uniforms.rainSpatialDensityX.value = v;
        // });
        //
        // gui.add(options,'rainSpatialDensityY',0.0,100.0,0.01).onChange((v) =>{
        //     this.material.uniforms.rainSpatialDensityY.value = v;
        // });
        //
        // gui.add(options,'rainMaxDensity',0.0,100.0,0.01).onChange((v) =>{
        //     this.material.uniforms.rainMaxDensity.value = v;
        // });
        //
        // gui.add(options,'rainSpeed',0.0,100.0,0.01).onChange((v) =>{
        //     this.material.uniforms.rainSpeed.value = v;
        // });
        //
        // gui.add(options,'dropletLength',0.0,100.0,0.01).onChange((v) =>{
        //     this.material.uniforms.dropletLength.value = v;
        // });
        //
        // gui.add(options,'dropletWidth',0.0,100.0,0.01).onChange((v) =>{
        //     this.material.uniforms.dropletWidth.value = v;
        // });

        this.#debug();

        return this;
    }

    enable() {
        if (!Weather.showed) return;
        this.effect.active = true;
        
        if (!projectMode.LiteMode.isActive()) {
            setFogParams({
                active: true,
                fogColor: "#4b5159",
                fogDensity: 0.95,
                fogFar: Rain.#params.fogFar,
                fogNear: 1
            });
        }
    }

    #debug() {
        if (!projectMode.LiteMode.debug) return;

        const folder = projectMode.LiteMode.debugFolder.addFolder('Rain');

        folder.add(Rain.#params,'rainSpatialDensityX', 0.0, 100.0, 0.001).onChange(value => {
            Rain.#material.uniforms.rainSpatialDensityX.value = value;
        });

        folder.add(Rain.#params,'rainSpatialDensityY', 0.0, 100.0, 0.001).onChange(value => {
            Rain.#material.uniforms.rainSpatialDensityY.value = value;
        });

        folder.add(Rain.#params,'rainMaxDensity', 0.0, 5.0, 0.001).onChange(value => {
            Rain.#material.uniforms.rainMaxDensity.value = value;
        });

        folder.add(Rain.#params,'rainSpeed', 0.0, 100.0, 0.001).onChange(value => {
            Rain.#material.uniforms.rainSpeed.value = value;
        });

        folder.add(Rain.#params,'dropletLength', 0.0, 5.0, 0.001).onChange(value => {
            Rain.#material.uniforms.dropletLength.value = value;
        });

        folder.add(Rain.#params,'dropletWidth', 0.0, 5.0, 0.001).onChange(value => {
            Rain.#material.uniforms.dropletWidth.value = value;
        });

    }

    disable() {
        this.effect.active = false;
        
        if (!projectMode.LiteMode.isActive()) {
            resetFogToDefault();
        }
    }

    static resetToDefault() {
        Rain.#material.uniforms.rainMaxDensity.value = Rain.#params.rainMaxDensity;
    }

    static setData(data) {
        if (!data.hasOwnProperty('rain')) return;

        Rain.#material.uniforms.rainMaxDensity.value = data.intensity;
    }

    update(time) {
        if (this.effect.active) {
            Rain.#material.uniforms.uTime.value = time;
        }
    }

}


class RainEffect extends Effect{
    constructor (material) {
        super();
        this.effect = new ShaderPass(material);
        this.active = false;
    }

}
